import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { toast } from "react-toastify";
import secureStorage from "../utils/secureStorage";
const API_URL = process.env.REACT_APP_API_URL;

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Detect route changes
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [user, setUser] = useState(null);
  const dropdownRef = useRef(null);

  console.log("User:", user);

  // Fetch user data from localStorage
  const fetchUser = () => {
    const userObj = secureStorage.get("user");
    if (userObj) {
      setUser(userObj);
      secureStorage.set("sessionStart", Date.now());
    } else {
      setUser(null);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  useEffect(() => {
    fetchUser();
  }, [location]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const sessionStart = secureStorage.get("sessionStart");
  //     if (sessionStart) {
  //       const elapsedTime = Date.now() - parseInt(sessionStart, 10);
  //       if (elapsedTime > SESSION_DURATION) {
  //         handleLogout();
  //       }
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);

  // Close dropdown when clicking outside

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     localStorage.clear();
  //   };
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  const handleLogout = async () => {
    const token = secureStorage.get("authToken");

    if (token) {
      try {
        const response = await fetch(`${API_URL}login/logout`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-HIP-ID": "healthidhub",
          },
        });

        if (response.ok) {
          toast.success("Logged out successfully!", {
            position: "top-right",
            autoClose: 2000,
          });
        } else {
          const error = await response.json();
          toast.error(error.message || "Logout failed", {
            position: "top-right",
            autoClose: 2000,
          });
        }
      } catch (err) {
        console.error("Logout error:", err);
        toast.error("Logout request failed", {
          position: "top-right",
          autoClose: 2000,
        });
      }
    }
    localStorage.clear();
    setUser(null);
    navigate("/login");
  };

  const handleLogoClick = () => {
    const localStorageRole = secureStorage.get("role");
    const userRole = user?.role;

    const role = userRole || localStorageRole;

    if (role === "HOSPITAL") {
      navigate("/hospital-dashboard");
    } else if (role === "USER") {
      navigate("/dashboard");
    } else {
      navigate("/");
    }

    // Optional: Log discrepancies for debugging
    if (userRole && localStorageRole && userRole !== localStorageRole) {
      console.warn("Discrepancy in roles detected:", {
        userRole,
        localStorageRole,
      });
    }
  };

  return (
    <header className="bg-white shadow-md">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        {/* Application Title */}
        <div
          onClick={handleLogoClick}
          className="cursor-pointer"
        >
          <h1 className="text-xl font-bold text-teal-600 leading-tight">
            {secureStorage.get("orgName") || "HealthIdHub"}
          </h1>
          <p className="text-xs text-teal-600 italic">powered by CureBay</p>
        </div>
        {/* Navigation Links */}
        <nav className="space-x-6 text-gray-600 flex items-center">
          {!user ? (
            <>
              <Link to="/login" className="hover:text-teal-500">
                Partner Login
              </Link>
              {/* <Link to="/dashboard" className="hover:text-teal-500">
                Dashboard
              </Link> */}
            </>
          ) : (
            <>
              {/* <Link to="/profile" className="hover:text-teal-500">
                ABHA Profile
              </Link> */}

              {/* Profile Image with Dropdown */}
              <div className="relative" ref={dropdownRef}>
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="flex items-center space-x-2 focus:outline-none"
                >
                  <div className="w-10 h-10 rounded-full border-2 border-teal-600 flex items-center justify-center bg-teal-500 text-white font-bold text-lg">
                    {user?.profilePhoto ? (
                      <img
                        src={`data:image/jpeg;base64,${user.profilePhoto}`}
                        alt="Profile"
                        className="w-full h-full rounded-full"
                      />
                    ) : (
                      // Show the first letter of the first name if no profile photo exists
                      <span>
                        {user?.firstName
                          ? user.firstName[0].toUpperCase()
                          : "U"}
                      </span>
                    )}
                  </div>
                  <span className="text-teal-600 font-medium">
                    {user?.firstName || "User"} {user?.middleName || ""}{" "}
                    {user?.lastName || ""}
                  </span>
                  <svg
                    className={`w-4 h-4 transform transition-transform ${
                      isDropdownOpen ? "rotate-180" : "rotate-0"
                    }`}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.292 7.707a1 1 0 011.415 0L10 10.999l3.293-3.292a1 1 0 011.415 1.414l-4 3.999a1 1 0 01-1.415 0l-4-3.999a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>

                {isDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-md py-2 z-50">
                    <button
                      onClick={handleLogout}
                      className="block px-4 py-2 text-gray-800 hover:bg-gray-100 w-full text-left"
                    >
                      <span className="flex items-center space-x-2">
                        <svg
                          className="w-5 h-5 text-blue-600"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 16l4-4m0 0l-4-4m4 4H7"
                          />
                        </svg>
                        <span>Logout</span>
                      </span>
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
